import React, { Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Box } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import tableStyle from './table.style';
import DropdownMenu from './dropdownMenu';
import EnhancedTableHead from './customTableHead';
import EnhancedTableToolbar from './customTableToolbar';
import { process } from '../utils';

function descendingComparator(a, b, orderBy) {
  if (
    orderBy !== 'fecha_esperada_termino' &&
    orderBy !== 'nombre_solicitante' &&
    orderBy !== 'etapa_actual_tabla' &&
    orderBy !== 'fecha_ingreso' &&
    orderBy !== 'fecha_esperada_termino'
  ) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  } else {
    if (orderBy === 'fecha_esperada_termino') {
      let fechaAuxA = process(a['vencimiento_raw']);
      let fechaAuxB = process(b['vencimiento_raw']);

      if (fechaAuxB < fechaAuxA) {
        return -1;
      }
      if (fechaAuxB > fechaAuxA) {
        return 1;
      }
    }
    if (orderBy === 'fecha_ingreso') {
      let fechaAuxA = process(a['fecha_ingreso']);
      let fechaAuxB = process(b['fecha_ingreso']);

      if (fechaAuxB < fechaAuxA) {
        return -1;
      }
      if (fechaAuxB > fechaAuxA) {
        return 1;
      }
    }
    if (orderBy === 'nombre_solicitante') {
      if (b['nombre_raw'] < a['nombre_raw']) {
        return -1;
      }
      if (b['nombre_raw'] > a['nombre_raw']) {
        return 1;
      }
    }
    if (orderBy === 'etapa_actual_tabla') {
      if (b['etapa_actual'] < a['etapa_actual']) {
        return -1;
      }
      if (b['etapa_actual'] > a['etapa_actual']) {
        return 1;
      }
    }
    if (orderBy === 'fecha_esperada_termino') {
      
      let fechaAuxA = process(a['fecha_etapa']);
      let fechaAuxB = process(b['fecha_etapa']);
      if (fechaAuxB < fechaAuxA) {
        return -1;
      }
      if (fechaAuxB > fechaAuxA) {
        return 1;
      }

    }
  }

  return 0;
}

const convertDateDMY = date => {
  // convierte fecha en formato "dd-mm-yyyy" a Date
  var dateParts = date.toString().split('-');
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
};

const convertDateYMD = date => {
  // convierte fecha en formato "yyyy-mm-dd" a Date
  var dateParts = date.toString().split('-');
  return new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
};

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export default function CustomTable(props) {
  const {
    headCells = [],
    rows = [],
    check = false,
    title = '',
    validation = [],
    search = false,
    actions = undefined,
    handleAction = undefined,
    add = null,
    addText = '',
    openModal,
    openModalSolicitudes,
  } = props;

  const classes = tableStyle();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [currentSearch, setCurrentSearch] = React.useState('');
  const [currentValidation, setCurrentValidation] = React.useState([]);
  const [reload, setReload] = React.useState(false);
  const [content, setContent] = React.useState(null);
  const [rowCount, setRowCount] = React.useState(0);
  // const debouncedSearchTerm = useDebounce(currentSearch, 500);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n[headCells[0].id]);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = event => {
    setDense(event.target.checked);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const forceReload = () => {
    setReload(!reload);
  };

  React.useEffect(() => {
    if (
      rows !== null &&
      page !== null &&
      rowsPerPage !== null &&
      rows !== undefined &&
      page !== undefined &&
      rowsPerPage !== undefined
    ) {
      if (rows.length && page > Math.ceil(rows.length / rowsPerPage) - 1) {
        setPage(page - 1);
      }
    }
  }, [rows, page, rowsPerPage]);

  React.useEffect(() => {
    const handleClick = (event, name) => {
      // const selectedIndex = selected.indexOf(name);
      // let newSelected = [];
      // if (selectedIndex === -1) {
      //   newSelected = newSelected.concat(selected, name);
      // } else if (selectedIndex === 0) {
      //   newSelected = newSelected.concat(selected.slice(1));
      // } else if (selectedIndex === selected.length - 1) {
      //   newSelected = newSelected.concat(selected.slice(0, -1));
      // } else if (selectedIndex > 0) {
      //   newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      // }
      // setSelected(newSelected);
    };

    const isSelected = name => selected.indexOf(name) !== -1;

    const getActions = (row, actions) => {
      let auxActions = [];

      actions.map((item, index) => {

        if (item.action === "monitorear") {
          if (!row.monitoreo) {
            auxActions.push(item)
          }
        } else if (item.action === "dejar_seguir") {
          if (row.monitoreo) {
            auxActions.push(item)
          }
        } else {
          auxActions.push(item);
        }

        return null;
      });

      return (
        <TableCell style={{ fontSize: 12 }} align="center" onClick={event => event.stopPropagation()}>
          <DropdownMenu
            items={auxActions}
            onItemClick={menu => {
              handleAction(menu, row);
            }}
            TriggerComponent={<MoreHoriz />}
          />
        </TableCell>
      );
    };

    const getDataForTable = (row, item, headIndex, index) => {
      if (item.id === 'nombre_solicitante') {
        return (
          <TableCell
            style={{ fontSize: 12, cursor: 'pointer' }}
            key={headIndex.toString()}
            onClick={() => {
              
              if (row.ux === 'atencion_usuarios' || row.ux === 'gestion_externa') {
                
                openModalSolicitudes(row)
              } else {
                openModal(row)
              }
            }}
            align={item.alignContent ? item.alignContent : 'left'}>
            {' '}
            {item.style && item.style !== undefined ? item.style(row[item.id], index) : row[item.id]}{' '}
          </TableCell>
        );
      } else {
        return (
          <TableCell
            style={{ fontSize: 12 }}
            key={headIndex.toString()}
            align={item.alignContent ? item.alignContent : 'left'}>
            {' '}
            {item.style && item.style !== undefined ? item.style(row[item.id], index) : row[item.id]}{' '}
          </TableCell>
        );
      }
    };

    const filteredRows = () => {
      var auxValidations = currentValidation.filter(v => !!v.value || !!v.min || !!v.max);
      const res = rows.filter((row, index) => {
        var res1 = true;
        var res2 = true;
        if (search && currentSearch) {
          res1 = false;
          headCells.forEach(cell => {

            /* se modifica la funcion mostrar para poder acceder a los datos raw de la fila, ya que normalmente el buscador no puede comparar objetos react */
            if (cell.id !== 'nombre_solicitante' && cell.id !== 'etapa_actual_tabla' && cell.id !== 'fecha_esperada_termino') {
              if (
                row[cell.id] &&
                row[cell.id]
                  .toString()
                  .toLowerCase()
                  .includes(currentSearch.toLowerCase())
              ) {
                res1 = true;
              }
            } else {
              if (cell.id === 'nombre_solicitante') {
                if (
                  row['nombre_raw'] &&
                  row['nombre_raw']
                    .toString()
                    .toLowerCase()
                    .includes(currentSearch.toLowerCase())
                ) {
                  res1 = true;
                }
              }

              if (cell.id === 'etapa_actual_tabla') {
                if (
                  row['etapa_actual'] &&
                  row['etapa_actual']
                    .toString()
                    .toLowerCase()
                    .includes(currentSearch.toLowerCase())
                ) {
                  res1 = true;
                }
              }

              if (cell.id === 'fecha_esperada_termino') {

                if (row.vencimiento_raw) {
                  if (
                    row['vencimiento_raw'] &&
                    row['vencimiento_raw']
                      .toString()
                      .toLowerCase()
                      .includes(currentSearch.toLowerCase())
                  ) {
                    res1 = true;
                  }
                } else {

                }
              }
            }

          });
        }
        if (auxValidations.length > 0) {
          auxValidations.forEach(validation => {
            if (validation.type === 'select') {
              if (row[validation.target].toString().toLowerCase() === validation.value.toLowerCase()) {
                res2 = res2 && true;
              } else {
                res2 = res2 && false;
              }
            }

            if (validation.type === 'select_list') {
              if (
                row[validation.target]
                  .map(item => {
                    return item.toLowerCase();
                  })
                  .includes(validation.value.toLowerCase())
              ) {
                res2 = res2 && true;
              } else {
                res2 = res2 && false;
              }
            }

            if (validation.type === 'numericRange') {
              if (
                validation.min &&
                validation.max &&
                Number(validation.min) <= Number(row[validation.target]) &&
                Number(row[validation.target]) <= Number(validation.max)
              ) {
                res2 = res2 && true;
              } else if (!validation.max && validation.min && Number(validation.min) <= Number(row[validation.target])) {
                res2 = res2 && true;
              } else if (!validation.min && validation.max && Number(row[validation.target]) <= Number(validation.max)) {
                res2 = res2 && true;
              } else {
                res2 = res2 && false;
              }
            }

            if (validation.type === 'dateRange') {
              if (
                validation.min &&
                validation.max &&
                convertDateYMD(validation.min) <= convertDateDMY(row[validation.target]) &&
                convertDateDMY(row[validation.target]) <= convertDateYMD(validation.max)
              ) {
                res2 = res2 && true;
              } else if (
                !validation.max &&
                validation.min &&
                convertDateYMD(validation.min) <= convertDateDMY(row[validation.target])
              ) {
                res2 = res2 && true;
              } else if (
                !validation.min &&
                validation.max &&
                convertDateDMY(row[validation.target]) <= convertDateYMD(validation.max)
              ) {
                res2 = res2 && true;
              } else {
                res2 = res2 && false;
              }
            }
          });
        }
        return res1 && res2;
      });
      setRowCount(res.length);
      return res;
    };

    setContent(
      stableSort(filteredRows(), getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          const isItemSelected = isSelected(index);
          const labelId = `enhanced-table-checkbox-${index}`;

          const isSeguimiento = row.isSeguimiento
          const isMonitoreado = row.monitoreo
          return (
            <TableRow
              style={{ backgroundColor: isSeguimiento && isMonitoreado ? '#edecd3' : null }} //le damos color especial en seguimiento para saber que lo estamos monitoreando
              hover
              onClick={event => handleClick(event, index)}
              role="checkbox"
              aria-checked={isItemSelected}
              tabIndex={-1}
              /* key={headCells.length > 0 ? row[headCells[0].id] : index} */
              key={index}
              selected={isItemSelected}>
              {check ? (
                <TableCell style={{ fontSize: 12 }} padding="checkbox">
                  <Checkbox checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                </TableCell>
              ) : (
                <Fragment />
              )}

              {headCells.map((item, headIndex) => {
                if (headIndex === 0) {
                  return (
                    <TableCell
                      style={{ fontSize: 12, cursor: 'pointer' }}
                      onClick={fila => {
                        console.log('fila',fila)
                        if (row.ux === 'atencion_usuarios' || row.ux === 'gestion_externa') {
                          openModalSolicitudes(row)
                        } else {
                          openModal(row)
                        }
                      }}
                      key={headIndex.toString()}
                      component="th"
                      id={labelId}
                      scope="row"
                      padding={row[item.disablePadding] ? 'none' : 'normal'}>
                      {' '}
                      {item.style && item.style !== undefined ? item.style(row[item.id], index) : row[item.id]}{' '}
                    </TableCell>
                  );
                } else {
                  return getDataForTable(row, item, headIndex, index);
                }
              })}

              {actions !== undefined ? getActions(row, actions) : null}
            </TableRow>
          );
        }),
    );
  }, [
    check,
    currentSearch,
    order,
    orderBy,
    page,
    rows,
    rowsPerPage,
    search,
    currentValidation,
    headCells,
    selected,
    actions,
    handleAction,
    reload,
  ]);

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          title={title}
          validation={validation}
          search={search}
          handleSearch={setCurrentSearch}
          handleValidation={setCurrentValidation}
          forceReload={forceReload}
          add={add}
          addText={addText}
        />
        <TableContainer>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table">
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rowCount}
              headCells={!!headCells ? headCells : []}
              check={check}
              actions={actions}
            />
            <TableBody>
              {content}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage="Tramites por página"
          labelDisplayedRows={({ from, to, count }) => ` Registro(s) ${from}-${to}  de ${count} registros`}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      {/* <FormControlLabel control={<Switch checked={dense} onChange={handleChangeDense} />} label="Dense padding" /> */}
    </Box>
  );
}
